<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Switch To Hd" class="d-icon d-icon--switch-to-hd" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M3.896.646a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .708l-1.25 1.25a.5.5 0 1 1-.708-.708l.397-.396H2.5a.5.5 0 0 1 0-1h1.793l-.397-.396a.5.5 0 0 1 0-.708ZM7.5 2a.5.5 0 0 1 .5-.5h2c.826 0 1.5.674 1.5 1.5v7c0 .826-.674 1.5-1.5 1.5H3A1.5 1.5 0 0 1 1.5 10V8.5a.5.5 0 0 1 1 0V10a.5.5 0 0 0 .5.5h7c.274 0 .5-.226.5-.5V3c0-.274-.226-.5-.5-.5H8a.5.5 0 0 1-.5-.5ZM2.604 3.146a.5.5 0 0 1 0 .708l-.397.396H4a.5.5 0 0 1 0 1H2.207l.397.396a.5.5 0 1 1-.708.708l-1.25-1.25a.5.5 0 0 1 0-.708l1.25-1.25a.5.5 0 0 1 .708 0ZM5.75 4.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V7h-1v1a.5.5 0 0 1-1 0V6.5a.5.5 0 0 1 .5-.5h1.5V5a.5.5 0 0 1 .5-.5Zm1 .5a.5.5 0 0 1 .5-.5h1A1.5 1.5 0 0 1 9.75 6v1a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 1-.5-.5V5Zm2 1a.5.5 0 0 0-.5-.5h-.5v2h.5a.5.5 0 0 0 .5-.5V6Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSwitchToHd',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
